import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media } from 'util/style-helpers';
import { BrandingType } from './Branding';

export const style: any = (styles: IGenericObject) => {
  const { type, isCopyStatic } = styles;
  return StyleSheet.create({
    brandingContainer: {
      display: 'flex',
      flexDirection: type === BrandingType.VERTICAL ? 'column' : 'row',
      alignItems: 'center',
      height: '100%',
      flexShrink: 0,
      flexGrow: type === BrandingType.VERTICAL ? 0 : 1,
      marginRight: type === BrandingType.VERTICAL ? 0 : 20,

      [media.tablet]: {
        flexShrink: 'initial',
        marginRight: 0,
      },
    },
    hiddenBranding: {
      visibility: 'hidden',

      [media.tablet]: {
        visibility: 'visible',
      },
    },
    logo: {
      [children('img')]: {
        width: type === BrandingType.VERTICAL ? 72 : 67,
        height: 'auto',
        paddingTop: type === BrandingType.VERTICAL ? 35 : 0,
        paddingBottom: type === BrandingType.VERTICAL ? 20 : 0,

        [media.tablet]: {
          width: type === BrandingType.VERTICAL ? 144 : 67,
          height: 'auto',
          paddingTop: type === BrandingType.VERTICAL ? 95 : 0,
          paddingBottom: type === BrandingType.VERTICAL ? 30 : 0,
        },
        [media.desktop]: {
          height: 'auto',
          paddingTop: type === BrandingType.VERTICAL ? 90 : 0,
        },
      },
    },
    copy: {
      textAlign: type === BrandingType.VERTICAL ? 'center' : 'left',
      fontSize: type === BrandingType.VERTICAL ? 25 : 0,
      display: type === BrandingType.VERTICAL || isCopyStatic ? 'block' : 'none',
      lineHeight: type === BrandingType.VERTICAL ? '28px' : '0px',
      width: type === BrandingType.VERTICAL ? 272 : 149,
      marginBottom: type === BrandingType.VERTICAL ? '15px' : '0px',
      marginLeft: type === BrandingType.VERTICAL ? 0 : 20,
      fontWeight: type === BrandingType.VERTICAL ? 'initial' : 700,
      maxWidth: 'fit-content',

      [children('span')]: {
        fontWeight: 700,
        whiteSpace: 'nowrap',
      },

      [media.tablet]: {
        display: 'block',
        fontSize: type === BrandingType.VERTICAL ? 45 : 12,
        lineHeight: type === BrandingType.VERTICAL ? '50px' : '15px',
        width: type === BrandingType.VERTICAL ? 480 : 150,
        marginBottom: type === BrandingType.VERTICAL ? '35px' : '0px',
        marginLeft: type === BrandingType.VERTICAL ? 0 : 10,
      },
      [media.desktop]: {
        fontSize: type === BrandingType.VERTICAL ? 50 : 20,
        lineHeight: type === BrandingType.VERTICAL ? '55px' : '24px',
        width: type === BrandingType.VERTICAL ? 532 : 213,
        marginLeft: type === BrandingType.VERTICAL ? 0 : 20,
      },
    },
  });
};
